{
  "recommendedAssetMix": "We Recommend this Asset Mix",
  "factorAffectingScore": "Factor Affecting your Score",
  "riskProfileIs": "Your Risk Profile is",
  "factorAffectingScoreDescription": "The following factors influence your risk profile.",
  "investmentKnowledge": "Investment Knowledge",
  "investmentKnowledgeOptions": {
    "NONE": "None",
    "LIMITED": "Limited",
    "SOME": "Some",
    "EXPERT": "Expert"
  },
  "timeHorizon": "Time Horizon",
  "goalTimeHorizon": {
    "VERY_SHORT_TERM": "Very Short Term",
    "SHORT_TERM": "Short Term",
    "MID_TERM": "Mid Term",
    "LONG_TERM": "Long Term",
    "VERY_LONG_TERM": "Very Long Term"
  },
  "riskProfileIsNotAvailable": "Not Available.",
  "previewRiskProfileName": "Medium",
  "previewRiskProfileDescription": "For clients willing to accept a moderate level of risk. You are looking to achieve high potential returns over the medium to long term under normal market conditions."
}
